import { IWho, WhoHttp } from '@rhybus/api'

import { apiPath, fetchProvider } from './api'

/**mpfWhoHttp:
 * Who - Access information about yourself and others.
 */
const mpfWhoHttp = (): IWho => {
  try {
    return new WhoHttp(fetchProvider, apiPath)
  } catch (error) {
    console.error(`
    Error while fetching the API using endpoint WhoHttp. \n
    fetchProvider:${fetchProvider} \n
    apiPath:${apiPath} \n
    Error:${error}`)
    throw error
  }
}

export { mpfWhoHttp }
